/**
 * GST state codes and GSTIN checks for the checkout form. The server applies
 * the same rules (backend/config/gst.js) and is the one that decides.
 */
export const GST_STATES = [
  ['35', 'Andaman and Nicobar Islands'],
  ['37', 'Andhra Pradesh'],
  ['12', 'Arunachal Pradesh'],
  ['18', 'Assam'],
  ['10', 'Bihar'],
  ['04', 'Chandigarh'],
  ['22', 'Chhattisgarh'],
  ['26', 'Dadra and Nagar Haveli and Daman and Diu'],
  ['07', 'Delhi'],
  ['30', 'Goa'],
  ['24', 'Gujarat'],
  ['06', 'Haryana'],
  ['02', 'Himachal Pradesh'],
  ['01', 'Jammu and Kashmir'],
  ['20', 'Jharkhand'],
  ['29', 'Karnataka'],
  ['32', 'Kerala'],
  ['38', 'Ladakh'],
  ['31', 'Lakshadweep'],
  ['23', 'Madhya Pradesh'],
  ['27', 'Maharashtra'],
  ['14', 'Manipur'],
  ['17', 'Meghalaya'],
  ['15', 'Mizoram'],
  ['13', 'Nagaland'],
  ['21', 'Odisha'],
  ['34', 'Puducherry'],
  ['03', 'Punjab'],
  ['08', 'Rajasthan'],
  ['11', 'Sikkim'],
  ['33', 'Tamil Nadu'],
  ['36', 'Telangana'],
  ['16', 'Tripura'],
  ['09', 'Uttar Pradesh'],
  ['05', 'Uttarakhand'],
  ['19', 'West Bengal'],
  ['97', 'Other Territory'],
];

const CODES = new Set(GST_STATES.map(([code]) => code));

export const normaliseGstin = (value) => String(value || '').replace(/\s+/g, '').toUpperCase();

export const isValidGstin = (gstin) =>
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(gstin) && CODES.has(gstin.slice(0, 2));

/** "₹2,999" from rupees. */
export const formatInr = (rupees) =>
  `₹${Number(rupees || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
